import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TipItem {
  id: number;
  tip_title: string;
  tip_content: string;
  category_name?: string;
  criteria_name?: string;
  delivery_method_name?: string;
  frequency?: string;
  priority?: number;
  createdon?: string;
}

interface Pagination {
  page?: number;
  per_page?: number;
  total_items?: number;
  total_pages?: number;
}

interface TipsState {
  tipsData: {
    tips: TipItem[];
    pagination?: Pagination;
  } | null;

  singleTipData: TipItem | null;

  categories: any[];
  criteria: any[];
  deliveryMethods: any[];

  tipSuccessMsg: {
    message: string;
    id: string | number;
  };

  tipErrorMsg: {
    message: string;
    id: string | number;
  };

  loading: boolean;
  pagination: Pagination | {};
}

export const initialState: TipsState = {
  tipsData: null,
  singleTipData: null,

  categories: [],
  criteria: [],
  deliveryMethods: [],

  tipSuccessMsg: { message: "", id: "" },
  tipErrorMsg: { message: "", id: "" },

  loading: false,
  pagination: {},
};

const tipsSlice = createSlice({
  name: "tips",
  initialState,
  reducers: {

    fetchTipsData(state, action: PayloadAction<any>) {
      state.tipsData = {
        tips: action.payload?.list || [],
        pagination: action.payload?.pagination || {},
      };
    },

    fetchSingleTipData(state, action: PayloadAction<any>) {
      state.singleTipData = action.payload?.single || null;
    },

    setPagination(state, action: PayloadAction<Pagination>) {
      state.pagination = action.payload || {};
    },

    fetchTipsCategories(state, action: PayloadAction<any[]>) {
      state.categories = action.payload || [];
    },

    fetchTipsCriteria(state, action: PayloadAction<any[]>) {
      state.criteria = action.payload || [];
    },

    fetchDeliveryMethods(state, action: PayloadAction<any[]>) {
      state.deliveryMethods = action.payload || [];
    },

    tipSuccessMsg(state, action) {
      state.tipSuccessMsg = action.payload;
    },

    tipErrorMsg(state, action) {
      state.tipErrorMsg = action.payload;
    },

    setTipLoader(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const {
  fetchTipsData,
  fetchSingleTipData,
  setPagination,
  fetchTipsCategories,
  fetchTipsCriteria,
  fetchDeliveryMethods,
  tipSuccessMsg,
  tipErrorMsg,
  setTipLoader,
} = tipsSlice.actions;

export default tipsSlice.reducer;
